(function () {
    "use strict";

    angular.module("app").controller("TaxesController", TaxesController);

    TaxesController.$inject = [
        "$scope",
        "$rootScope",
        "$timeout",
        "$filter",
        "$uibModal",
        "blockUI",
        "ExportService",
        "SelectService",
        "CustomPreferencesService",
        "CorporateCustomerService",
        "NotifyService",
        "LoyaltyService",
    ];

    function TaxesController(
        $scope,
        $rootScope,
        $timeout,
        $filter,
        $uibModal,
        blockUI,
        ExportService,
        SelectService,
        CustomPreferencesService,
        CorporateCustomerService,
        NotifyService,
        LoyaltyService
    ) {
        $scope.getFiltersList = SelectService.getLPList;

        $scope.getTaxes = getTaxes;
        $scope.getTaxesItems = getTaxesItems;
        $scope.state = {
            currentTab: "taxes",
        };
        $scope.classifications = [
            {id: "all", title: "All"},
            {id: "base-tax", title: "Tax classification#base-tax"},
            {id: "sales-tax", title: "Tax classification#sales-tax"},
        ];

        $scope.userIdTypes = [
            {id: "phone", title: "Phone"},
            {id: "email", title: "Email"},
            {id: "id", title: "Id"},
            {id: "external-id", title: "External id"},
        ];

        $scope.model = {
            by_stock: false,
        };

        $scope.params = {
            classification: null,
            taxes_preset: {
                date_from: moment().subtract(1, "month").utc().toDate(),
                date_to: moment().endOf("day").utc().toDate(),
                pos_id: null,
                tax_classification: null,
                tax_id: null,
                tax_code: null,
                user_id_value: null,
                user_id_type: null,
                corporate_customer_email: null,
            },
            taxes_items_preset: {
                date_from: moment().subtract(1, "month").utc().toDate(),
                date_to: moment().endOf("day").utc().toDate(),
                pos_id: null,
                tax_classification: null,
                tax_id: null,
                tax_code: null,
                item_id: null,
                item_code: null,
                user_id_value: null,
                user_id_type: null,
                corporate_customer_email: null,
            },
        };

        $scope.data = {
            showTableDisplaySettings: false,
            isFilePreparing: false,
            currentUserIdType: null,
            taxesList: null,
            taxesItemsList: null,
        };

        $scope.data.taxes_table_cols_preset = [
            {
                visible: true,
                enabled: true,
                data: [
                    {
                        value: "tax_classification",
                        text: "Classification tax",
                        visible: true,
                    },
                ],
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {value: "tax_code", text: "Tax code", visible: true},
                ],
            },
            {
                visible: true,
                enabled: true,
                data: [{value: "tax_title", text: "Title tax", visible: true}],
            },
            {
                visible: true,
                enabled: true,
                data: [{value: "tax_amount", text: "Amount", visible: true}],
            },
        ];
        // Добавляем возможность отобразить пустую колонку в экспортируемом документе
        $scope.data.taxes_table_cols_preset =
            CustomPreferencesService.addBlankColumns(
                $scope.data.taxes_table_cols_preset
            );

        $scope.data.taxes_items_table_cols_preset = [
            {
                visible: true,
                enabled: true,
                data: [
                    {
                        value: "item_classification",
                        text: "",
                        visible: true,
                    },
                ],
            },
            {
                visible: true,
                enabled: true,
                data: [
                    {
                        value: "item_code",
                        text: "TEXT_LIST_BUSINESS_CODE",
                        visible: true,
                    },
                ],
            },
            {
                visible: true,
                enabled: true,
                data: [{value: "item_title", text: "Title tax", visible: true}],
            },
            {
                visible: true,
                enabled: true,
                data: [{value: "tax_amount", text: "Amount", visible: true}],
            },
        ];
        // Добавляем возможность отобразить пустую колонку в экспортируемом документе
        $scope.data.taxes_items_table_cols_preset =
            CustomPreferencesService.addBlankColumns(
                $scope.data.taxes_items_table_cols_preset
            );
        // Список форматов дат для настройки полей с датами
        $scope.dateFormats = CustomPreferencesService.dateFormats;
        $scope.data.exportHeaders = true;

        var block_taxes_list = blockUI.instances.get("taxes_list");
        var block_taxes_items_list = blockUI.instances.get("taxes_items_list");

        initController();

        function initController() {
            initTaxesFiters();
            initTaxesItemsFiters();
        }

        function initTaxesFiters() {
            $scope.params.taxes = angular.copy($scope.params.taxes_preset);
        }

        function initTaxesItemsFiters() {
            $scope.params.taxesItems = angular.copy($scope.params.taxes_items_preset);
        }

        function getTaxes() {
            block_taxes_list.start();
            $scope.data.taxesList = null;

            var params = angular.copy($scope.params.taxes);

            params.date_from = moment(params.date_from).set({
                hour: moment(params.time_from).get("hour"),
                minute: moment(params.time_from).get("minute"),
                second: moment(params.time_from).get("second"),
            });
            delete params.time_from;

            params.date_to = moment(params.date_to).set({
                hour: moment(params.time_to).get("hour"),
                minute: moment(params.time_to).get("minute"),
                second: moment(params.time_to).get("second"),
            });
            delete params.time_to;

            params = dateFieldsFormat(params, null, "YYYY-MM-DD[T]HH:mm:ss[Z]", true);
            params = cleanRequestData(params);

            var loyalty_id = $scope.data.currentFilter.id;

            if ($scope.data.currentFilter.filter_list_type == "pos") {
                loyalty_id = $scope.data.currentFilter.loyalty_id;
            }

            if (params.corporate_customer_email) {
                var corporateCustomerParams = {
                    email: params.corporate_customer_email
                }
                params.corporate_customer_email = null;
                params = cleanRequestData(params);
                CorporateCustomerService.All(corporateCustomerParams, function (success, response) {
                    if (!success) {
                        return
                    }
                    if (response.data.length == 0) {
                        NotifyService.Error($filter("translate")('find_customer#not found'))
                        block_taxes_list.stop();
                        return
                    }
                    params.corporate_customer_id = response.data[0].id;
                    LoyaltyService.GetTaxesSummaryItems(
                        loyalty_id,
                        params,
                        function (success, response) {
                            if (success) {
                                $scope.data.taxesList = response;
                            }
                            $timeout(function () {
                                block_taxes_list.stop();
                            }, 1000);
                        }
                    );
                });
            } else {
                params = cleanRequestData(params);
                LoyaltyService.GetTaxesSummaryItems(
                    loyalty_id,
                    params,
                    function (success, response) {
                        if (success) {
                            $scope.data.taxesList = response;
                        }
                        $timeout(function () {
                            block_taxes_list.stop();
                        }, 1000);
                    }
                );
            }
        }

        function getTaxesItems() {
            block_taxes_items_list.start();
            $scope.data.taxesItemsList = null;

            var params = angular.copy($scope.params.taxesItems);

            params.date_from = moment(params.date_from).set({
                hour: moment(params.time_from).get("hour"),
                minute: moment(params.time_from).get("minute"),
                second: moment(params.time_from).get("second"),
            });
            delete params.time_from;

            params.date_to = moment(params.date_to).set({
                hour: moment(params.time_to).get("hour"),
                minute: moment(params.time_to).get("minute"),
                second: moment(params.time_to).get("second"),
            });
            delete params.time_to;

            params = dateFieldsFormat(params, null, "YYYY-MM-DD[T]HH:mm:ss[Z]", true);


            var loyalty_id = $scope.data.currentFilter.id;

            if ($scope.data.currentFilter.filter_list_type == "pos") {
                loyalty_id = $scope.data.currentFilter.loyalty_id;
            }

            params.corporate_customer_id = null;

            if (params.corporate_customer_email) {
                var corporateCustomerParams = {
                    email: params.corporate_customer_email
                }
                params.corporate_customer_email = null;
                params = cleanRequestData(params);
                CorporateCustomerService.All(corporateCustomerParams, function (success, response) {
                    if (!success) {
                        return
                    }
                    if (response.data.length == 0) {
                        NotifyService.Error($filter("translate")('find_customer#not found'))
                        block_taxes_items_list.stop();
                        return
                    }
                    params.corporate_customer_id = response.data[0].id;
                    LoyaltyService.GetTaxesSummaryItems(
                        loyalty_id,
                        params,
                        function (success, response) {
                            if (success) {
                                $scope.data.taxesItemsList = response;
                            }
                            $timeout(function () {
                                block_taxes_items_list.stop();
                            }, 1000);
                        }
                    );
                });
            } else {
                params = cleanRequestData(params);
                LoyaltyService.GetTaxesSummaryItems(
                    loyalty_id,
                    params,
                    function (success, response) {
                        if (success) {
                            $scope.data.taxesItemsList = response;
                        }
                        $timeout(function () {
                            block_taxes_items_list.stop();
                        }, 1000);
                    }
                );
            }
        }

        $scope.onChangeClassifications = function () {
            if ($scope.params.classification === "all") {
                if ($scope.state.currentTab === "taxes") {
                    $scope.params.taxes.tax_classification = null;
                } else {
                    $scope.params.taxesItems.tax_classification = null;
                }
                return;
            }
            if ($scope.state.currentTab === "taxes") {
                $scope.params.taxes.tax_classification = $scope.params.classification;
            } else {
                $scope.params.taxesItems.tax_classification =
                    $scope.params.classification;
            }
        };

        $scope.onChangeTab = function (tab, update) {
            $scope.state.currentTab = tab;
        };

        $scope.onTaxesExport = function (format) {
            var isExportStopped = false;
            // TODO dsвынестиоздание модального окна в exportService
            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: "static",
                templateUrl: "app/templates/modal.export.html",
                controllerAs: "exportModal",
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused =
                            !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    };

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        block_taxes_list.stop();
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                },
            });

            $scope.data.isFilePreparing = true;
            block_taxes_list.start();

            var params = angular.copy($scope.params.taxes);
            params.date_from = moment(params.date_from).set({
                hour: moment(params.time_from).get("hour"),
                minute: moment(params.time_from).get("minute"),
                second: moment(params.time_from).get("second"),
            });
            delete params.time_from;

            params.date_to = moment(params.date_to).set({
                hour: moment(params.time_to).get("hour"),
                minute: moment(params.time_to).get("minute"),
                second: moment(params.time_to).get("second"),
            });
            delete params.time_to;

            params = dateFieldsFormat(
                params,
                null,
                "YYYY-MM-DD[T]HH:mm:ss[Z]",
                false
            );
            params = cleanRequestData(params);
            var taxes = $scope.data.taxesList;
            var export_struct = ExportService.getTableForExcel(
                format,
                angular.copy($scope.data.taxes_table_cols_preset)
            );

            function generateFile() {
                var file_name =
                    $rootScope.ENV.business.code +
                    "_taxes_" +
                    moment($scope.params.taxes.date_from).format("YYYY-MM-DD_HH:mm:ss") +
                    "_" +
                    moment($scope.params.taxes.date_to).format("YYYY-MM-DD_HH:mm:ss");

                var export_data = [];

                if (taxes.length > 0) {
                    for (var taxIndex in taxes) {
                        var el = {};
                        for (var fieldIndex in export_struct) {
                            var fieldName, fieldValue;
                            fieldName = export_struct[fieldIndex].text;

                            switch (export_struct[fieldIndex].value) {
                                case "tax_classification":
                                    fieldValue = $filter("translate")(
                                        "Tax classification#" +
                                        taxes[taxIndex][export_struct[fieldIndex].value]
                                    );
                                    break;
                                case "tax_code":
                                    fieldValue = taxes[taxIndex][export_struct[fieldIndex].value];
                                    break;

                                case "tax_title":
                                    fieldValue = taxes[taxIndex][export_struct[fieldIndex].value];
                                    break;

                                case "tax_amount":
                                    fieldValue = taxes[taxIndex][export_struct[fieldIndex].value];
                                    break;

                                default:
                                    fieldValue =
                                        taxes[taxIndex][export_struct[fieldIndex].value] === null
                                            ? ""
                                            : taxes[taxIndex][export_struct[fieldIndex].value];
                            }
                            // customer fields
                            el[fieldName] = fieldValue || "";
                        }
                        export_data.push(el);
                    }
                } else {
                    /*if there is no transaction, show only headers*/
                    var emptyEl = {};
                    for (var fieldIndex in export_struct) {
                        var emptyFieldName = export_struct[fieldIndex].text;
                        if (emptyFieldName.trim() !== "") {
                            emptyEl[emptyFieldName] = "";
                            export_data.push(emptyEl);
                        }
                    }
                }

                $scope.$evalAsync(function ($scope) {
                    block_taxes_list.stop();
                    $scope.data.isFilePreparing = false;
                });

                // параметр utf8Bom нужен для экспорта без заголовков, иначе слетает кодировка
                switch (format) {
                    case "XLSX":
                        alasql(
                            'SELECT * INTO XLSX("' +
                            file_name +
                            '.xlsx",{headers:' +
                            $scope.data.exportHeaders +
                            ", utf8Bom:true}) FROM ?",
                            [export_data]
                        );
                        break;
                    case "XLS":
                        alasql(
                            'SELECT * INTO XLS("' +
                            file_name +
                            '.xls",{headers:' +
                            $scope.data.exportHeaders +
                            ", utf8Bom:true}) FROM ?",
                            [export_data]
                        );
                        break;
                    case "CSV":
                        alasql(
                            'SELECT * INTO CSV("' +
                            file_name +
                            '.csv",{headers:' +
                            $scope.data.exportHeaders +
                            ', separator:",", utf8Bom:true}) FROM ?',
                            [export_data]
                        );
                        break;
                }
            }

            function exportRequest() {
                generateFile();
                setTimeout(() => {
                    $scope.modalExport.close();
                }, 600);
            }

            exportRequest();
        };

        $scope.onTaxesItemsExport = function (format) {
            var isExportStopped = false;
            // TODO dsвынестиоздание модального окна в exportService
            $scope.modalExport = $uibModal.open({
                animation: true,
                keyboard: false,
                backdrop: "static",
                templateUrl: "app/templates/modal.export.html",
                controllerAs: "exportModal",
                controller: function ($uibModalInstance) {
                    $scope.exportModal = this;

                    // Прогресс загрузки в процентах
                    $scope.exportModal.exportProgress = 0.1;

                    // Количество загруженных записей
                    $scope.exportModal.downloadedDataCount = 0;

                    // Все количество загружаемых записей
                    $scope.exportModal.allDataCount = 0;

                    // Признак - находится ли экспорт на паузе
                    $scope.exportModal.isExportPaused = false;

                    $scope.exportModal.onTogglePause = function () {
                        $scope.exportModal.isExportPaused =
                            !$scope.exportModal.isExportPaused;
                        if (!$scope.exportModal.isExportPaused) {
                            exportRequest();
                        }
                    };

                    $scope.exportModal.onStop = function () {
                        isExportStopped = true;
                        $scope.modalExport.close();
                        if ($scope.exportModal.isExportPaused) {
                            handleExportResults();
                        }
                    };

                    $scope.exportModal.onExit = function () {
                        $scope.exportModal.isExportPaused = true;
                        block_taxes_items_list.stop();
                        $scope.data.isFilePreparing = false;
                        $uibModalInstance.close();
                    };
                },
            });

            $scope.data.isFilePreparing = true;
            block_taxes_items_list.start();
            var params = angular.copy($scope.params.taxesItems);

            params.date_from = moment(params.date_from).set({
                hour: moment(params.time_from).get("hour"),
                minute: moment(params.time_from).get("minute"),
                second: moment(params.time_from).get("second"),
            });
            delete params.time_from;

            params.date_to = moment(params.date_to).set({
                hour: moment(params.time_to).get("hour"),
                minute: moment(params.time_to).get("minute"),
                second: moment(params.time_to).get("second"),
            });
            delete params.time_to;

            params = dateFieldsFormat(
                params,
                null,
                "YYYY-MM-DD[T]HH:mm:ss[Z]",
                false
            );
            params = cleanRequestData(params);
            var taxes = $scope.data.taxesItemsList;
            var export_struct = ExportService.getTableForExcel(
                format,
                angular.copy($scope.data.taxes_table_cols_preset)
            );
            var export_struct_items = ExportService.getTableForExcel(
                format,
                angular.copy($scope.data.taxes_items_table_cols_preset)
            );

            function generateFile() {
                var file_name =
                    $rootScope.ENV.business.code +
                    "_taxes_items_" +
                    moment($scope.params.taxesItems.date_from).format("YYYY-MM-DD_HH:mm:ss") +
                    "_" +
                    moment($scope.params.taxesItems.date_to).format("YYYY-MM-DD_HH:mm:ss");

                var export_data = [];

                if (taxes.length > 0) {
                    for (var taxIndex in taxes) {
                        var el = {};
                        for (var fieldIndex in export_struct) {
                            var fieldName, fieldValue;
                            fieldName = export_struct[fieldIndex].text;

                            switch (export_struct[fieldIndex].value) {
                                case "tax_classification":
                                    fieldValue = $filter("translate")(
                                        "Tax classification#" +
                                        taxes[taxIndex][export_struct[fieldIndex].value]
                                    );
                                    break;
                                case "tax_code":
                                    fieldValue = taxes[taxIndex][export_struct[fieldIndex].value];
                                    break;

                                case "tax_title":
                                    fieldValue = taxes[taxIndex][export_struct[fieldIndex].value];
                                    break;

                                case "tax_amount":
                                    fieldValue = taxes[taxIndex][export_struct[fieldIndex].value];
                                    break;

                                default:
                                    fieldValue =
                                        taxes[taxIndex][export_struct[fieldIndex].value] === null
                                            ? ""
                                            : taxes[taxIndex][export_struct[fieldIndex].value];
                            }
                            el[fieldName] = fieldValue || "";
                        }
                        export_data.push(el);

                        if (taxes[taxIndex].items && taxes[taxIndex].items.length) {
                            for (var itemIndex in taxes[taxIndex].items) {
                                var elItem = {};
                                for (var fieldItemIndex in export_struct_items) {
                                    var fieldItemName, fieldItemValue;
                                    fieldItemName = export_struct_items[fieldItemIndex].text;

                                    switch (export_struct_items[fieldItemIndex].value) {
                                        case "item_classification":
                                            fieldItemValue = "";
                                            break;
                                        case "item_code":
                                            fieldItemValue =
                                                taxes[taxIndex].items[itemIndex].item_code;
                                            break;

                                        case "item_title":
                                            fieldItemValue =
                                                taxes[taxIndex].items[itemIndex].item_title;
                                            break;

                                        case "tax_amount":
                                            fieldItemValue =
                                                taxes[taxIndex].items[itemIndex].tax_amount;
                                            break;

                                        default:
                                            fieldItemValue =
                                                taxes[taxIndex][
                                                    export_struct_items[fieldItemIndex].value
                                                    ] === null
                                                    ? ""
                                                    : taxes[taxIndex][
                                                        export_struct_items[fieldItemIndex].value
                                                        ];
                                    }
                                    elItem[fieldItemName] = fieldItemValue || "";
                                }
                                export_data.push(elItem);
                            }
                        }
                    }
                } else {
                    /*if there is no transaction, show only headers*/
                    var emptyEl = {};
                    for (var fieldIndex in export_struct) {
                        var emptyFieldName = export_struct[fieldIndex].text;
                        if (emptyFieldName.trim() !== "") {
                            emptyEl[emptyFieldName] = "";
                            export_data.push(emptyEl);
                        }
                    }
                }

                $scope.$evalAsync(function ($scope) {
                    block_taxes_items_list.stop();
                    $scope.data.isFilePreparing = false;
                });

                // параметр utf8Bom нужен для экспорта без заголовков, иначе слетает кодировка
                switch (format) {
                    case "XLSX":
                        alasql(
                            'SELECT * INTO XLSX("' +
                            file_name +
                            '.xlsx",{headers:' +
                            $scope.data.exportHeaders +
                            ", utf8Bom:true}) FROM ?",
                            [export_data]
                        );
                        break;
                    case "XLS":
                        alasql(
                            'SELECT * INTO XLS("' +
                            file_name +
                            '.xls",{headers:' +
                            $scope.data.exportHeaders +
                            ", utf8Bom:true}) FROM ?",
                            [export_data]
                        );
                        break;
                    case "CSV":
                        alasql(
                            'SELECT * INTO CSV("' +
                            file_name +
                            '.csv",{headers:' +
                            $scope.data.exportHeaders +
                            ', separator:",", utf8Bom:true}) FROM ?',
                            [export_data]
                        );
                        break;
                }
            }

            function exportRequest() {
                generateFile();
                setTimeout(() => {
                    $scope.modalExport.close();
                }, 600);
            }

            exportRequest();
        };

        $rootScope.$watch("LP_LIST", function (newValue, oldValue) {
            if (newValue && newValue.length > 0) {
                $scope.data.filtersList = angular.copy($rootScope.LP_LIST);
                if (
                    $rootScope.ENV.filters.global_filter &&
                    $rootScope.ENV.filters.global_filter.loyalty_id !== "0"
                ) {
                    $scope.data.currentFilter = $scope.data.filtersList.find(function (
                        filterItem
                    ) {
                        if (filterItem.filter_list_type === "loyalty") {
                            if (
                                filterItem.id ===
                                $rootScope.ENV.filters.global_filter.loyalty_id
                            ) {
                                return true;
                            }
                        } else if (filterItem.filter_list_type === "pos") {
                            if (
                                filterItem.loyalty_id ===
                                $rootScope.ENV.filters.global_filter.loyalty_id
                            ) {
                                return true;
                            }
                        }
                    });
                } else {
                    $scope.data.currentFilter = getFirstActive($scope.data.filtersList);
                }
            }
        });

        $scope.$watch(
            "data.currentFilter",
            function (newValue, oldValue) {
                if (newValue) {
                    var l = $rootScope.ENV.filters.orders_list;
                    if (l) l.filter = newValue;
                    else l = {filter: newValue};

                    $rootScope.ENV.filters.orders_list = l;

                    if (l.filter.filter_list_type === "loyalty") {
                        $rootScope.ENV.filters.global_filter = {loyalty_id: l.filter.id};
                        $scope.params.taxes.pos_id = null;
                        $scope.params.taxesItems.pos_id = null;
                    } else if (l.filter.filter_list_type === "pos") {
                        $rootScope.ENV.filters.global_filter = {
                            loyalty_id: l.filter.loyalty_id,
                        };
                        $scope.params.taxes.pos_id = l.filter.id;
                        $scope.params.taxesItems.pos_id = l.filter.id;
                    }

                    $rootScope.storeENV();
                }
            },
            true
        );

        var dateDiff =
            appConfig.dateDifferences && appConfig.dateDifferences.taxes
                ? appConfig.dateDifferences.taxes
                : 1;

        $scope.$watch("params.taxes.date_to", function (newValue, oldValue) {
            if (
                !!newValue &&
                moment(newValue).diff($scope.params.taxes.date_from, "months", true) >
                dateDiff
            )
                $scope.params.taxes.date_from = moment($scope.params.taxes.date_to)
                    .subtract(dateDiff, "month")
                    .utc()
                    .toDate();
        });

        $scope.$watch("params.taxes.date_from", function (newValue, oldValue) {
            if (
                !!newValue &&
                moment($scope.params.taxes.date_to).diff(newValue, "months", true) >
                dateDiff
            )
                $scope.params.taxes.date_to = moment($scope.params.taxes.date_from)
                    .add(dateDiff, "month")
                    .utc()
                    .toDate();
        });

        $scope.$watch("params.taxesItems.date_to", function (newValue, oldValue) {
            if (
                !!newValue &&
                moment(newValue).diff(
                    $scope.params.taxesItems.date_from,
                    "months",
                    true
                ) > dateDiff
            )
                $scope.params.taxesItems.date_from = moment(
                    $scope.params.taxesItems.date_to
                )
                    .subtract(dateDiff, "month")
                    .utc()
                    .toDate();
        });

        $scope.$watch("params.taxesItems.date_from", function (newValue, oldValue) {
            if (
                !!newValue &&
                moment($scope.params.taxesItems.date_to).diff(
                    newValue,
                    "months",
                    true
                ) > dateDiff
            )
                $scope.params.taxesItems.date_to = moment(
                    $scope.params.taxesItems.date_from
                )
                    .add(dateDiff, "month")
                    .utc()
                    .toDate();
        });
    }
})();
